import { useTranslation } from 'react-i18next'

import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { getApplicantFormOptionalLabel } from '../../../../../RentalPortalApplicant'
import { TextareaOutlineField } from '../../../../../Textarea'
import {
  APPLICANT_FORM_FIELD_NAME_MESSAGE,
  APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH,
  APPLICANT_FORM_MESSAGE_FIELD_MIN_ROWS,
} from '../../RentalPortalApplicantForm.constants'

function MessageField() {
  const { t } = useTranslation()

  return (
    <FormikField
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      fieldComponentProps={{
        label: getApplicantFormOptionalLabel({
          label: t('RentalPortal.ApplicantFormMessageLabelKey'),
          t,
        }),
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      maxLength={APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH}
      minRows={APPLICANT_FORM_MESSAGE_FIELD_MIN_ROWS}
      name={APPLICANT_FORM_FIELD_NAME_MESSAGE}
      placeholder={t('RentalPortal.ApplicantFormMessagePlaceholderKey')}
    />
  )
}

export default MessageField
